import { render, staticRenderFns } from "./ComponentItemView.vue?vue&type=template&id=351e33e2&"
import script from "./ComponentItemView.vue?vue&type=script&lang=ts&"
export * from "./ComponentItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports